<template>
 <v-container>
   <v-card>
     <v-card-title>
       แต่งตั้งคณะกรรมการ
     </v-card-title>
     <v-card-text>
       <v-list>
         <v-list-item>
           <v-row class="justify-center">
             <v-col
                 cols="12"
                 md="6">
               <v-autocomplete
                   v-model="dep_id"
                   label="หน่วยงาน/ภาควิชา"
                   :items="depart"
                   item-text="dep_name"
                   item-value="dep_id"
                   :error="dep_id == ''"
                   :error-messages="dep_id == '' ? 'หน่วยงาน/ภาควิชา (ห้ามว่าง)' : ''"
                   persistent-hint
                   outlined
                   clearable
               >
               </v-autocomplete>
             </v-col>
           </v-row>
         </v-list-item>
         <v-list-item>
           <v-row class="justify-center">
             <v-col
               cols="12"
               md="6">
               <v-text-field
                   v-model="Topic"
                   outlined
                   label="ชื่อเรื่อง"
                   :error="Topic == ''"
                   :error-messages="Topic == '' ? 'ชื่อเรื่อง (ห้ามว่าง)' : ''"
                   persistent-hint
                   required
               ></v-text-field>
             </v-col>
             <v-col
               cols="12"
               md="2">
               <v-text-field
                   v-model="No"
                   outlined
                   label="เลขที่คำสั่ง"
                   :error="No == ''"
                   :error-messages="No == '' ? 'เลขที่คำสั่ง (ห้ามว่าง)' : ''"
                   persistent-hint
                   required
               ></v-text-field>
             </v-col>
             <v-col
               cols="12"
               md="2">
               <v-select
                 v-model="CommandT"
                :items="CommandType"
                item-value="id"
                item-text="type"
                 label="ประเภทที่คำสั่ง"
                 :error="CommandT == ''"
                 :error-messages="CommandT == '' ? 'ประเภทที่คำสั่ง (ห้ามว่าง)' : ''"
                 persistent-hint
                 required
                 outlined
               ></v-select>
             </v-col>
           </v-row>
         </v-list-item>
         <v-list-item>
           <v-row class="justify-center">
             <v-col
                 cols="12"
                 md="6">
               <v-textarea
                   v-model="Rm"
                   outlined
                   label="รายละเอียดเพิ่มเติม (ถ้ามี)"
               ></v-textarea>
             </v-col>
           </v-row>
         </v-list-item>
         <v-list-item>
           <v-row class="justify-center">
             <v-col
                 cols="12"
                 md="4">
               <v-text-field
                   v-model="Date_Start"
                   outlined
                   label="วันที่เริ่มต้น (เป็นคณะกรรมการ)"
                   type="date"
                   :error="Date_Start == ''"
                   :error-messages="Date_Start == '' ? 'วันที่เริ่มต้น (ห้ามว่าง)' : ''"
                   persistent-hint
                   required
               ></v-text-field>
             </v-col>
             <v-col
                 cols="2"
                 md="2">
               <div align="center" class="mt-4">
                 ถึง
               </div>
             </v-col>
             <v-col
                 cols="12"
                 md="4">
               <v-text-field
                   outlined
                   label="วันที่สิ้นสุด (เป็นคณะกรรมการ)"
                   type="date"
               ></v-text-field>
             </v-col>
           </v-row>
         </v-list-item>
         <v-list-item>
           <v-file-input
               v-model="files"
               color="deep-purple accent-4"
               counter
               label="แนบไฟล์เอกสารประกอบการแต่งตั้ง"
               multiple
               placeholder="เลือกไฟล์"
               prepend-icon="mdi-paperclip"
               outlined
               :show-size="1000"
               @change="FileSelect"
           >
             <template v-slot:selection="{ index, text }">
               <v-chip
                   v-if="index < 5"
                   color="deep-purple accent-4"
                   dark
                   label
                   small
               >
                 {{ text }}
               </v-chip>

               <span
                   v-else-if="index === 5"
                   class="overline grey--text text--darken-3 mx-2"
               >
                                +{{ files.length - 2 }} File(s)
                              </span>
             </template>
           </v-file-input>
         </v-list-item>
         <v-list-item>
           <v-alert
               v-if="alert"
               prominent
               type="error"
           >
             <v-row align="center" v-for="item in txtAlert" :key="item.id">
               <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
             </v-row>
           </v-alert>
         </v-list-item>
         <v-list-item v-if="FileAppointment.length > 0">
           <template>
             <v-row>
               <v-col cols="12" sm="6" offset-sm="3">
                 <v-card>
                   <v-card-title>
                     ไฟล์ภาพประกอบ
                   </v-card-title>
                   <v-container fluid>
                     <v-row>
                       <v-col
                           v-for="(file_i, index) in FileAppointment"
                           :key="index"
                           class="d-flex child-flex"
                           cols="12"
                           md="4"
                       >
                         <v-card flat tile class="d-flex">
                           <v-img
                               v-if="file_i.type == 'image'"
                               :src="file_i.src"
                               :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                               aspect-ratio="1"
                               class="grey lighten-2"
                           >
                             <template v-slot:placeholder>
                               <v-row
                                   class="fill-height ma-0"
                                   align="center"
                                   justify="center"
                               >
                                 <v-progress-circular
                                     indeterminate
                                     color="grey lighten-5"></v-progress-circular>
                               </v-row>
                             </template>
                           </v-img>
                           <v-img
                               v-if="file_i.type == 'pdf'"
                               src="../../assets/Image/pdf.png"
                               :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                               aspect-ratio="1"
                               class="grey lighten-2"
                           >
                             <template v-slot:placeholder>
                               <v-row
                                   class="fill-height ma-0"
                                   align="center"
                                   justify="center"
                               >
                                 <v-progress-circular
                                     indeterminate
                                     color="grey lighten-5"></v-progress-circular>
                               </v-row>
                             </template>
                           </v-img>
                           <v-card-actions>
                             <v-btn text
                                    @click="ShowData(file_i.src)">
                                                                                        <span style="color: indigo">
                                                                                            เรียกดู
                                                                                        </span>
                             </v-btn>
                           </v-card-actions>
                         </v-card>
                       </v-col>
                     </v-row>
                   </v-container>
                 </v-card>
               </v-col>
             </v-row>
           </template>
         </v-list-item>
         <v-list-item>
           <v-card style="width: 100%">
             <v-card-subtitle class="font-weight-bold text--black">
               เพิ่มรายชื่อคณะกรรมการ
             </v-card-subtitle>
             <v-list>
               <v-list-item>
                 <v-row class="justify-center">
                   <v-col
                     cols="12"
                     md="6">
                     <v-autocomplete
                         v-model="staffSel"
                         label="ค้นหาบุคลากร"
                         :items="staffData"
                         item-text="customDetail"
                         item-value="perid"
                         hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                         persistent-hint
                         clearable
                         outlined
                         @keyup="checkKeyEnter"
                     ></v-autocomplete>
                   </v-col>
                   <v-col
                       cols="12"
                       md="4">
                     <v-autocomplete
                         v-model="Committee_code"
                         :items="committee_Posi.filter(item => item.committee_type == '0' || item.committee_type == '2')"
                         item-text="committee_des"
                         item-value="Committee_code"
                         label="ตำแหน่ง"
                         outlined
                         required
                     ></v-autocomplete>
                   </v-col>
                   <v-col
                       class="d-flex justify-center"
                     cols="12"
                     md="2">
                   <v-btn outlined color="green" class="mt-2" @click="insertCommittee">เพิ่ม</v-btn>
                 </v-col>
                 </v-row>
               </v-list-item>
               <div align="center">
                 <v-chip color="primary" dark>
                   คณะกรรมการจำนวน {{Commitee.length}} คน
                 </v-chip>
               </div>
               <v-list-item>
                 <v-data-table
                     style="width: 100%"
                   :headers="headerAppointment"
                   :items="Commitee">

                 </v-data-table>
               </v-list-item>
             </v-list>
           </v-card>
         </v-list-item>
         <div align="center" class="mt-6">
           <v-btn outlined color="green" class="text--darken-2" @click="saveAppointment">บันทึกข้อมูล</v-btn>
         </div>
       </v-list>
     </v-card-text>
   </v-card>
 </v-container>
</template>

<script>
// import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";
import {mapActions, mapGetters} from "vuex";
export default {
  name: "InsertAppointment",
  data() {
    return{
      CommandT: '',
      Topic: '',
      No: '',
      Rm: '',
      Date_Start: '',
      Date_End: '',
      dep_id: '',
      Committee_code: '',
      Commitee: [],
      staffSel: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      files: [],
      alert: false,
      txtAlert: [],
      FileAppointment: [],
      headerAppointment: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'หน่วยงาน', value: 'dep_name'},
        {text: 'ตำแหน่ง', value: 'committee_des'},
        {text: '', value: 'action'},
      ],
      headerAxiosPUT: {
        headers: {
          'X-REST-METHOD': 'PUT'
        }
      },
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      staffData: 'Staff/getStaff',
      depart: 'Depart/getDepart',
      committee_Posi: 'Project/getComitteeType',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      PermissionAdmin: 'Permission/getPermission',
      Permission: 'Permission/getPermissionUser',
      CommandType: 'Appointment/getAppointmentCommandData',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initDepartData: 'Depart/initDepartData',
      initStaffData: 'Staff/initStaffData',
      initComitteeType: 'Project/initComitteeType',
      getPermissionDep: 'Permission/getPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionData: 'Permission/getPermissionData',
      initAppointmentCommandData: 'Appointment/initAppointmentCommandData',
    }),
    init() {
      this.getInitData()
    },
    getInitData() {
      this.initAppointmentCommandData()
      this.initDepartData()
      this.initStaffData().then(res => {
        if (res) {
          if (this.staffData.length > 0) {
            this.staffData.map(item => {
              item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
            })
          }
        }
      })
      this.initComitteeType()
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        this.insertCommittee()
      }
    },
    insertCommittee() {
      if (this.staffSel == '' || this.Committee_code == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูลบุคลากร และ ตำแหน่งให้ครบถ้วน!!'
        })
      } else {
        if (this.Commitee.length > 0) {
          if (this.Commitee.filter(item => item.perid == this.staffSel).length > 0) {
            this.staffSel = ''
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด บุคลากรที่เลือกมีข้อมูลอยู่แล้ว!!'
            })
          } else {
            var Staff = this.staffData.filter(item => item.perid == this.staffSel)
            if (Staff.length > 0) {
              this.Commitee.push({
                ...Staff[0],
                Committee_code: this.Committee_code,
                committee_des: this.committee_Posi.filter(item => item.Committee_code == this.Committee_code)[0].committee_des,
                idx: 0
              })
              this.Commitee.map((item, idx) => {
                item.idx = idx + 1
              })
            }
          }
        } else {
          Staff = this.staffData.filter(item => item.perid == this.staffSel)
          if (Staff.length > 0) {
            this.Commitee.push({
              ...Staff[0],
              Committee_code: this.Committee_code,
              committee_des: this.committee_Posi.filter(item => item.Committee_code == this.Committee_code)[0].committee_des,
              // idx: this.Commitee.length + 1
              idx: 0
            })
            this.Commitee.map((item, idx) => {
              item.idx = idx + 1
            })
          }
        }
        this.staffSel = ''
      }
    },
    saveAppointment() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึก",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          if (this.Topic == '' || this.No == '' || this.CommandT == '' || this.Date_Start == '' || this.dep_id == '') {
            this.$swal.fire({
              icon: 'error',
              title: 'โปรดกรอกข้อมูลช่องสีแดงให้ครบถ้วน!!'
            })
          } else {
            var Ref_id = ''
            var countTeam = 0
            Ref_id = this.getRandomFileName()
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Appointment/', {
              Topic: this.Topic,
              No: this.No,
              Appointment_Command_id: this.CommandT,
              Rm: this.Rm,
              Date_Start: this.Date_Start,
              Date_End: this.Date_End,
              dep_id: this.dep_id,
              Ref_id: Ref_id,
              create_by: this.MeData[0].perid,
              create_time: 'now()',
            }, this.headerAxiosPUT).then(res => {
              if (res.data.status) {
                if (this.Commitee.length > 0) {
                  this.Commitee.map(item => {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Appointment_Team/', {
                      perid: item.perid,
                      C_Committee_code: item.Committee_code,
                      Ref_id: Ref_id,
                      create_by: this.MeData[0].perid,
                      create_time: 'now()',
                    }, this.headerAxiosPUT).then(res2 => {
                      if (res2.data.status) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts', {
                          perid: item.perid,
                          subject: this.Topic,
                          type: item.Committee_code,
                          Project_code: '',
                          date_start: this.Date_Start,
                          date_end: this.Date_End,
                          Rm: 'เลขที่คำสั่ง : ' + this.No + ' ประเภทคำสั่ง : ' + this.CommandType.filter(itemC => itemC.id == this.CommandT)[0].type + ' ' + this.Rm,
                          Ref_id: Ref_id,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                          update_by: this.MeData[0].perid,
                        }, this.headerAxiosPUT)
                        countTeam++
                      } else {
                        countTeam++
                      }
                      if (countTeam == this.Commitee.length) {
                        if (this.FileAppointment.length > 0) {
                          var countFileAppointment = 0
                          this.FileAppointment.map((item) => {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                              File_name: item.name,
                              File_path: item.path,
                              File_type: item.type,
                              Ref_id: Ref_id,
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }, this.headerAxiosPUT).then(res => {
                              if (res.data.status) {
                                countFileAppointment++
                              } else {
                                countFileAppointment++
                              }
                              if (countFileAppointment == this.FileAppointment.length) {
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ!!'
                                })
                                this.Topic = ''
                                this.No = ''
                                this.Rm = ''
                                this.CommandT = ''
                                this.Date_Start = ''
                                this.Date_End = ''
                                this.dep_id = ''
                                this.Commitee = []
                                this.FileAppointment = []
                                this.files = []
                                this.alert = false
                              }
                            })
                          })
                        } else {
                          this.$swal.fire({
                            icon: 'success',
                            title: 'บันทึกข้อมูลสำเร็จ!!'
                          })
                          this.Topic = ''
                          this.No = ''
                          this.Rm = ''
                          this.CommandT = ''
                          this.Date_Start = ''
                          this.Date_End = ''
                          this.dep_id = ''
                          this.Commitee = []
                          this.FileAppointment = []
                          this.files = []
                          this.alert = false
                        }
                      }
                    })
                  })
                } else {
                  if (this.FileAppointment.length > 0) {
                    var countFileAppointment = 0
                    this.FileAppointment.map((item) => {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                        File_name: item.name,
                        File_path: item.path,
                        File_type: item.type,
                        Ref_id: Ref_id,
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      }, this.headerAxiosPUT).then(res => {
                        if (res.data.status) {
                          countFileAppointment++
                        } else {
                          countFileAppointment++
                        }
                        if (countFileAppointment == this.FileAppointment.length) {
                          this.$swal.fire({
                            icon: 'success',
                            title: 'บันทึกข้อมูลสำเร็จ!!'
                          })
                          this.Topic = ''
                          this.No = ''
                          this.Rm = ''
                          this.CommandT = ''
                          this.Date_Start = ''
                          this.Date_End = ''
                          this.dep_id = ''
                          this.Commitee = []
                          this.FileAppointment = []
                          this.files = []
                          this.alert = false
                        }
                      })
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ!!'
                    })
                    this.Topic = ''
                    this.No = ''
                    this.CommandT = ''
                    this.Rm = ''
                    this.Date_Start = ''
                    this.Date_End = ''
                    this.dep_id = ''
                    this.Commitee = []
                    this.FileAppointment = []
                    this.files = []
                    this.alert = false
                  }
                }
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง!!'
                })
              }
            })
          }
        }
      })
    },
    getRandomFileName() {
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      return random_number;
    },
    FileSelect: function () {
      // var count = 0
      this.txtAlert = []
      this.FileAppointment = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 2048 * 2048) {
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 4 mb*'
              })
            }
          } else {
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
          }
        })
      }

      if (this.txtAlert.length == 0) {
        this.files.map((item) => {
          const fd = new FormData()
          fd.append('file', item, item.name)
          const headerAxios = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'WithCredentials': true,
              "Access-Control-Allow-Origin": "*"
              // "Accept": 'multipart/form-data'
            }
          }

          axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
            if (res.data.status) {
              switch (item.type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileAppointment.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'image',
                    type_Img: item.type
                  })
                  break
                case 'application/pdf':
                  this.FileAppointment.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'pdf',
                    type_Img: item.type
                  })
                  break
                default:
                  break
              }

              // count++
              //
              // if (count === this.files.length) {
              //     this.FileAppointmentPdf = []
              //     this.FileAppointment = []
              // }
            }
          })
        })

      } else {
        this.alert = true
      }
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
  },
  mounted() {
    this.initMeData().then(res => {
      if (res) {
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(resAdmin => {
          if (resAdmin) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '13000') {
                this.CheckAdmin = true
                this.init()
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.$router.push('/')
                }
              }
            })
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(resUser => {
              if (resUser) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '13000') {
                    this.CheckSubAdmin = true
                    this.init()
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.CheckSubAdmin = false
                this.CheckAdmin = false
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>